import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-top":"20px"} }
const _hoisted_2 = { style: {"background-color":"#ffffff","height":"80px"} }
const _hoisted_3 = { class: "header-group" }
const _hoisted_4 = { class: "header-logo" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "header-logo",
  "max-width": "550"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "nom-outil" }, "Mon Réservoir Utilisable")
], -1)
const _hoisted_6 = { class: "nav-bar" }
const _hoisted_7 = { class: "links" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.arvalis.fr/outils-et-services/outils-et-fiches",
  class: "link",
  target: "_blank"
}, "Plus d'outils", -1)

import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'visAppBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: "img/logo_arvalis.png",
            alt: "Logo",
            class: "logo-arvalis-header",
            "min-width": "188",
            width: "270",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/')), ["prevent"]))
          })
        ]),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Accueil")
          ]),
          _: 1
        }),
        _createTextVNode(" | "),
        _createVNode(_component_router_link, {
          to: "/about",
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("En savoir plus")
          ]),
          _: 1
        }),
        _createTextVNode(" | "),
        _hoisted_8
      ])
    ])
  ]))
}
}

})